import React from 'react';
import { Navigate } from 'react-router-dom';
import { isGameUnlocked } from '../utils/questUtils';

interface ProtectedGameRouteProps {
  children: React.ReactNode;
  requiredXP: number;
}

const ProtectedGameRoute: React.FC<ProtectedGameRouteProps> = ({ children, requiredXP }) => {
  const unlocked = isGameUnlocked(requiredXP);

  if (!unlocked) {
    // Redirect to games page if game is locked
    return <Navigate to="/games" replace />;
  }

  return <>{children}</>;
};

export default ProtectedGameRoute;
